var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "filters filters--events",
      attrs: { autocomplete: "off", "accept-charset": "UTF-8" }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "scroll", value: "events" }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.view,
            expression: "view"
          }
        ],
        attrs: { type: "hidden", name: "view", value: "" },
        domProps: { value: _vm.view },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.view = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "filter filter--buttons", class: _vm.view }, [
        _c(
          "button",
          {
            staticClass: "map",
            attrs: { type: "button", value: "map" },
            on: {
              click: function($event) {
                return _vm.setView("map")
              }
            }
          },
          [_vm._v("\n            Kaartweergave\n        ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "list",
            attrs: { type: "button", value: "list" },
            on: {
              click: function($event) {
                return _vm.setView("list")
              }
            }
          },
          [_vm._v("\n            Lijstweergave\n        ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter filter--city" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.postcode,
                expression: "postcode"
              }
            ],
            attrs: { type: "hidden", name: "postcode" },
            domProps: { value: _vm.postcode },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.postcode = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.stad,
                expression: "stad"
              }
            ],
            attrs: { type: "hidden", name: "stad" },
            domProps: { value: _vm.stad },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.stad = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.land,
                expression: "land"
              }
            ],
            attrs: { type: "hidden", name: "land" },
            domProps: { value: _vm.land },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.land = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "story-filter-city" } }, [
            _vm._v("Gemeente")
          ]),
          _vm._v(" "),
          _c(
            "v-select",
            {
              attrs: {
                label: "label",
                clearable: false,
                value: _vm.city,
                options: _vm.cityOptions,
                id: "story-filter-city",
                placeholder: "Postcode en stad"
              },
              on: { search: _vm.onSearch, input: _vm.setCity }
            },
            [
              _c("div", { attrs: { slot: "no-options" }, slot: "no-options" }, [
                _vm._v("Typ een postcode of een stad")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filters__submit" }, [
      _c("input", {
        staticClass: "btn btn--green",
        attrs: { type: "submit", value: "Zoek" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }